import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Portfolio from "./components/Portfolio";
import AboutPage from "./components/AboutPage";
import DesignProcess from "./components/DesignProcess";
import Contact from "./components/Contact";
import BxKicks from "./components/case-studies/BxKicks";
import TwentyFourHourFitness from "./components/case-studies/TwentyFourHourFitness";
import KoniagGovernmentServices from "./components/case-studies/KoniagGovernmentServices";
import Scite from "./components/case-studies/Scite";
import FitnessByArtizen from "./components/case-studies/FitnessByArtizen";
import MyProtocol from "./components/case-studies/MyProtocol";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/process" element={<DesignProcess />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/case-studies/bx-kicks" element={<BxKicks />} />
          <Route path="/case-studies/24-hour-fitness" element={<TwentyFourHourFitness />} />
          <Route path="/case-studies/koniag-government-services" element={<KoniagGovernmentServices />} />
          <Route path="/case-studies/scite" element={<Scite />} />
          <Route path="/case-studies/fitness-by-artizen" element={<FitnessByArtizen />} />
          <Route path="/case-studies/my-protocol" element={<MyProtocol />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;